import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Particle from "../Particle";
import Loading from "../Loading";
import { useData } from "../../context/DataContext";
import { useTranslation } from "react-i18next";
import { BsBriefcase } from "react-icons/bs";

function Experience() {
  const { t, i18n } = useTranslation();
  const { resume: resumeData, loading } = useData();
  const lang = i18n.language.split("-")[0];

  const experiences = resumeData?.experience || [];

  const getLabel = (obj, l) => {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    return obj[l] || obj["en"] || "";
  };

  if (loading) {
    return <Loading message="Loading Experience..." />;
  }

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row className="mb-5">
          <Col>
            <h1 className="project-heading text-center">
              <BsBriefcase className="me-3" />
              {t("work_experience", "Work Experience").split(" ")[0]}{" "}
              <strong className="purple">
                {t("work_experience", "Work Experience").split(" ")[1]}
              </strong>
            </h1>
            <p
              className="text-center text-white"
              style={{ fontSize: "1.1rem", marginTop: "20px" }}
            >
              {t(
                "work_experience_description",
                "My professional work experience and participation in various projects."
              )}
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col md={10}>
            {experiences.length === 0 ? (
              <p className="text-white text-center">No experience added yet.</p>
            ) : (
              experiences.map((exp, index) => (
                <Card
                  key={exp._id}
                  className="experience-card mb-4"
                  style={{
                    backgroundColor: "rgba(25, 25, 35, 0.8)",
                    border: "1px solid rgba(199, 112, 240, 0.3)",
                    borderRadius: "15px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.borderColor =
                      "rgba(199, 112, 240, 0.8)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.borderColor =
                      "rgba(199, 112, 240, 0.3)";
                  }}
                >
                  <Card.Body className="p-4">
                    <div className="d-flex justify-content-between align-items-start flex-wrap mb-3">
                      <div style={{ textAlign: "left" }}>
                        <h3
                          className="purple mb-2"
                          style={{
                            fontSize: "1.8rem",
                            fontWeight: "600",
                            textAlign: "left",
                          }}
                        >
                          {exp.company}
                        </h3>
                        <h4
                          className="text-white mb-2"
                          style={{
                            fontSize: "1.3rem",
                            fontWeight: "500",
                            textAlign: "left",
                          }}
                        >
                          {getLabel(exp.role, lang)}
                        </h4>
                      </div>
                      <span
                        className="badge"
                        style={{
                          backgroundColor: "rgba(199, 112, 240, 0.2)",
                          color: "#c770f0",
                          padding: "8px 16px",
                          fontSize: "0.9rem",
                          borderRadius: "20px",
                          flexShrink: 0,
                        }}
                      >
                        {exp.period}
                      </span>
                    </div>

                    <p
                      className="text-white"
                      style={{
                        fontSize: "1.05rem",
                        lineHeight: "1.8",
                        textAlign: "left",
                        marginBottom: "0",
                      }}
                    >
                      {getLabel(exp.description, lang)}
                    </p>
                  </Card.Body>
                </Card>
              ))
            )}
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Experience;
